import React, { Component, useState } from "react";
import Slider from "react-slick";
import asmr from "./assets/asmr.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./assets/feature.scss";


export default class Suggestions extends Component {

  constructor(props, context) {
    super(props, context);
    this.title = 'Have you tried ASMR?';
    this.handleSelect = this.handleSelect.bind(this);

    this.state = {
      index: 0,
      setIndex: 0,
      setDirection: null,
      direction: null,
    };
  }

  handleSelect(selectedIndex, e) {
    this.setState({
      index: selectedIndex,
      direction: e.direction,
    });
  }

  render() {
    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    const { index, direction } = this.state;
    // const fade = false;
    // const controls = false;
    // const interval = 300;

    return (

      <div className="row">
        <Slider {...settings}>
          <div>
            <div className="col-md-6 col-sm-12">
              <img
                className="slider-image"
                src={asmr}
                alt="asmr"
              />
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="row asmr-content">
                <h2 className="section-title">{this.title}</h2>
                <p className="lead">Autonomous Sensory Meridian Response</p>
                <p>Is a sensation triggered by certain sounds, a tingling or euphoric feeling can
                overcome the listener. Not everyone experiences the same sensations but why not
        try it out to see if it helps you sleep, be calm and relax.</p>
                <div className="secondary-cta">
                  <a href="#">learn more</a>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="col-md-6 col-sm-12">
              <div className="row asmr-content">
                <h2 className="section-title">{this.title}</h2>
                <p className="lead">Autonomous Sensory Meridian Response</p>
                <p>Is a sensation triggered by certain sounds, a tingling or euphoric feeling can
                overcome the listener. Not everyone experiences the same sensations but why not
        try it out to see if it helps you sleep, be calm and relax.</p>
                <div className="secondary-cta">
                  <a href="#">learn more</a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <img
                className="slider-img"
                src={asmr}
                alt="asmr"
              />
            </div>
          </div>
          <div>
            <div className="col-md-6 col-sm-12">
              <img
                className="slider-image"
                src={asmr}
                alt="asmr"
              />
            </div>
            <div className="col-md-6 col-sm-12">
              <div className="row asmr-content">
                <h2 className="section-title">{this.title}</h2>
                <p className="lead">Autonomous Sensory Meridian Response</p>
                <p>Is a sensation triggered by certain sounds, a tingling or euphoric feeling can
                overcome the listener. Not everyone experiences the same sensations but why not
        try it out to see if it helps you sleep, be calm and relax.</p>
                <div className="secondary-cta">
                  <a href="#">learn more</a>
                </div>
              </div>
            </div>
          </div>
        </Slider>


      </div >
    );

  }

}

// <div className="col-lg-6 col-sm-12">
//   <div className="row">
//     <img src={asmr} alt="asmr" />
//   </div>
// </div>
// <div className="col-lg-6 col-sm-12">
//   <div className="row asmr-content">
//     <h2 className="section-title">{this.title}</h2>
//     <p className="lead">Autonomous Sensory Meridian Response</p>
//     <p>Is a sensation triggered by certain sounds, a tingling or euphoric feeling can
//     overcome the listener. Not everyone experiences the same sensations but why not
//     try it out to see if it helps you sleep, be calm and relax.</p>
//     <div className="secondary-cta">
//       <a href="#">learn more</a>
//     </div>
//   </div>
// </div>


{/* <Carousel>
<div className="slide1">
  <div className="col-lg-4 col-sm-12">
    <img
      className="d-block w-100"
      src={asmr}
      alt="asmr"
    />
  </div>
  <div className="col-lg-6 col-sm-12">
    <div className="row asmr-content">
      <h2 className="section-title">{this.title}</h2>
      <p className="lead">Autonomous Sensory Meridian Response</p>
      <p>Is a sensation triggered by certain sounds, a tingling or euphoric feeling can
      overcome the listener. Not everyone experiences the same sensations but why not
        try it out to see if it helps you sleep, be calm and relax.</p>
      <div className="secondary-cta">
        <a href="#">learn more</a>
      </div>
    </div>
  </div>
</div>
<div className="slide2">
  <div className="col-lg-4 col-sm-12">
    <img
      className="d-block w-100"
      src={asmr}
      alt="asmr"
    />
  </div>
  <div className="col-lg-6 col-sm-12">
    <div className="row asmr-content">
      <h2 className="section-title">{this.title}</h2>
      <p className="lead">testetetetete</p>
      <p>Is a sensation triggered by certain sounds, a tingling or euphoric feeling can
      overcome the listener. Not everyone experiences the same sensations but why not
        try it out to see if it helps you sleep, be calm and relax.</p>
      <div className="secondary-cta">
        <a href="#">learn more</a>
      </div>
    </div>
  </div>
</div>
</Carousel> */}


// WEBPACK FOOTER //
// ./src/containers/main/features/Suggestions.js